/**
 * Identity function - returns the input value unchanged
 * @param value - The value to return
 * @returns The same value that was passed in
 */
export const Identity = <T>(value: T): T => value
